export enum ToolEnum {
  'wireless' = 1,
  'ipr' = 2,
  'voip' = 3,
  'actionitem' = 4,
  'generalalert' = 5,
  'jsi360' = 6,
  'briefingServices' = 7,
  'crra' = 8,
  'trfa' = 9,
  // 'intermediateProviderRegistry' = 10,
  'redLightStatus' = 11,
  'carrierTariffs' = 12,
  'commissionWebsites' = 13,
  'rateResources' = 14,
  'cpcnCertificates' = 15,
  'secretaryofStatesAuthorization' = 16,
  'exemptionCertificates' = 17,
  'Tax Documents' = 18,
  'ratesManagementSystem' = 19,
  'tarrifsnet' = 20,
  'RMD' = 21,
  'inrollACP' = 22,
  'training' = 23,
  'state911' = 24,
  'exportCitiation' = 25,
  'specialReport' = 27,
  'webinar' = 28,
  'whitepapers' = 29,
  'TRFAexportCitiation' = 30,
  'TRSCustomerNotice' = 33,
  'JSIResources' = 35,
  'View47' = 36,
  'PricingQuote' = 37,
  'QuotesAndProposals' = 38,
  'TaxExemptionForms' = 40,
  'ipcs' = 41,
  'MyFiles' = 43,
  'inrollLifeline' = 54,
  'JSI360Resources' = 56,
  'CarrierFCCObligation' = 57,
  'TrackNow'= 42
}

export enum ActionStatusList {
  'pending' = 1,
  'notapplicable' = 2,
  'acknowledged' = 3,
  'done' = 4,
  'informativeonly' = 5
}

export enum AdminUserType {
  'systemadmin' = 1,
  'systemuser' = 2
}

export enum ActionActivity {
  'Wireless' = 1,
  'IPR' = 2,
  'VoIP' = 3,
  'Trac It' = 4,
  // 'I360 Alert' = 5,
  // 'I360' = 6,
  'Briefing Services' = 7,
  'CRRA' = 8,
  'TRFA' = 9,
  // 'Red Light Status' = 10,
  'Carrier Tariffs' = 11,
  'Commission Websites' = 12,
  'Local Rate Information' = 13,
  'Exemption Certificates' = 14,
  'CPCN Certificates' = 15,
  'Secretary of States Authorization' = 16,
  'Tariffs.net' = 17,
  'Tax Documents' = 18,
  'Rates Management System' = 19,
  'News' = 20,
  'Webinar Libary' = 21,
  'Inroll ACP' = 51, // 22 Done
  'Training' = 29,  // 23 Done
  'State911' = 50,  // 24 Done
  'Home' = 23,
  'My Library' = 24,
  'REMS' = 25,
  'Robocall Mitigation Database' = 52,
  'Special Report' = 28,
  'White Papers' = 30,
  'Seminars' = 26, // Done
  'My Files' = 43, // Done
  'Company Directory' = 32, // Done
  'Change Password' = 45, // Done
  'Logout' = 53, // Done
  'Transactional Tax Login' = 41, // Done
  'JSI360 Internal Use Only' = 44, // Done
  'Inroll Lifeline' = 54, // Done
  'Manage Customer Resources' = 55,
  'TRS Customer Notice' = 33,
  'JSI360 Resources' = 56,
  'View 47' = 57,
  'PricingQuote' = 37,
  'QuotesAndProposals' = 38,
  'Onboarding' = 39,
  'Tax Exemption Forms' = 40,
  'IPCS' = 59,
  'TrackNow'= 42
}

export const ApplicationActivityProductList: any = [
  { id: 1, itemName: 'Wireless' },
  { id: 2, itemName: 'IPR' },
  { id: 3, itemName: 'VoIP' },
  { id: 4, itemName: 'Trac It' },
  { id: 7, itemName: 'Briefing Services' },
  { id: 8, itemName: 'CRRA' },
  { id: 9, itemName: 'TRFA' },
  { id: 11, itemName: 'Carrier Tariffs' },
  { id: 12, itemName: 'Commission Websites' },
  { id: 13, itemName: 'Local Rate Information' },
  { id: 14, itemName: 'Exemption Certificates' },
  { id: 15, itemName: 'CPCN Certificates' },
  { id: 16, itemName: 'Secretary of States Authorization' },
  { id: 17, itemName: 'Tariffs.net' },
  { id: 18, itemName: 'Tax Documents' },
  { id: 19, itemName: 'Rates Management System' },
  { id: 20, itemName: 'News' },
  { id: 21, itemName: 'Webinar Libary' },
  { id: 23, itemName: 'Home' },
  { id: 24, itemName: 'My Library' },
  { id: 25, itemName: 'REMS' },
  { id: 26, itemName: 'Seminars' },
  { id: 28, itemName: 'Special Report' },
  { id: 29, itemName: 'Training' },
  { id: 30, itemName: 'White Papers' },
  { id: 32, itemName: 'Company Directory' },
  { id: 41, itemName: 'Transactional Tax Login' },
  { id: 43, itemName: 'My Files' },
  { id: 45, itemName: 'Change Password' },
  { id: 50, itemName: '911' },
  // {id: 51, itemName: 'Inroll Claims ACP'},
  { id: 52, itemName: 'Robocall Mitigation Database' },
  { id: 53, itemName: 'Logout' },
  { id: 54, itemName: 'Inroll Claims Lifeline' },
  { id: 55, itemName: 'Manage Customer Resources' },
  { id: 56, itemName: 'JSI360 Resources' },
  { id: 33, itemName: 'TRS Customer Notice' },
  { id: 57, itemName: 'View 47' },
  { id: 38, itemName: 'Quotes And Proposals' },
  { id: 58, itemName: 'Company Profile' },
  { id: 40, itemName: 'Tax Exemption Forms' },
  { id: 37, itemName: 'Price Quote' },
  { id: 59, itemName: 'IPCS' },
];

export enum EnumFavorites {
  'Rate911' = 1,
  'Future911' = 2,
  'TRFAFund' = 3,
  'TRFAUpdates' = 4,
  'TRFA' = 5,
  'Data911' = 6
}

export enum BaseRateType {
  'BaseRate' = 1,
  'AddOn(InteserraPlatformOffering)' = 2,
  'AddOn(OtherRegulatoryRequirement)' = 3,
  'MiscFee' = 4,
  'Compliance' = 5
}

export enum AddOnFixPrice {
  'VoiceOnly' = 1575,
  'VoiceWithBroadBandh' = 2100
}

export enum StateEnum {
  'Alabama' = 1,
  'Alaska' = 2,
  'Arizona' = 3,
  'Arkansas' = 4,
  'California' = 5,
  'Colorado' = 6,
  'Connecticut' = 7,
  'Delaware' = 8,
  'District Of Columbia' = 9,
  'Florida' = 10,
  'Georgia' = 11,
  'Hawaii' = 12,
  'Idaho' = 13,
  'Illinois' = 14,
  'Indiana' = 15,
  'Iowa' = 16,
  'Kansas' = 17,
  'Kentucky' = 18,
  'Louisiana' = 19,
  'Maine' = 20,
  'Maryland' = 21,
  'Massachusetts' = 22,
  'Michigan' = 23,
  'Minnesota' = 24,
  'Mississippi' = 25,
  'Missouri' = 26,
  'Montana' = 27,
  'Nebraska' = 28,
  'Nevada' = 29,
  'New Hampshire' = 30,
  'New Jersey' = 31,
  'New Mexico' = 32,
  'New York' = 33,
  'North Carolina' = 34,
  'North Dakota' = 35,
  'Ohio' = 36,
  'Oklahoma' = 37,
  'Oregon' = 38,
  'Pennsylvania' = 39,
  'Rhode Island' = 40,
  'South Carolina' = 41,
  'South Dakota' = 42,
  'Tennessee' = 43,
  'Texas' = 44,
  'Utah' = 45,
  'Vermont' = 46,
  'Virginia' = 47,
  'Washington' = 48,
  'WestVirginia' = 49,
  'Wisconsin' = 50,
  'Wyoming' = 51,
  'FCC' = 53,
  'Puerto Rico' = 54,
  'American Samoa' = 55,
  'Guam' = 56,
  'Northern Mariana Islands' = 57,
  'US Virgin Islands' = 58,
  'Canada' = 59,
  'FE-DOE' = 60,
  'Government' = 61,
  'Outside the US' = 63,
  'Other' = 64
}